import { gql } from '@apollo/client';
export const StatFeatureSubType = gql `
    fragment StatFeatureSubType on SubTypeFeatureSettingsFlags {
        isRestricted
        required
    }
`;
